const pageNameKey = "drawerModal";

export const drawerModalEn = {
  [pageNameKey]: {
    close: "Close",
  },
};

export const drawerModalPtBr = {
  [pageNameKey]: {
    close: "Fechar",
  },
};

export const drawerModalDe = {
  [pageNameKey]: {
    close: "Schließen",
  },
};

export const drawerModalZhHans = {
  [pageNameKey]: {
    close: "关闭",
  },
};

export const drawerModalIt = {
  [pageNameKey]: {
    close: "Chiudi",
  },
};

export const drawerModalEs = {
  [pageNameKey]: {
    close: "Cerrar",
  },
};

export const drawerModalNl = {
  [pageNameKey]: {
    close: "Sluiten",
  },
};

export const drawerModalTr = {
  [pageNameKey]: {
    close: "Kapat",
  },
};
